//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ReplyModal from "../components/ReplyModal.vue";
import tweetsAPI from "../apis/tweets";
import { fromNowFilter } from "./../utils/mixins";
import { Toast } from "./../utils/helpers";
import BetterScroll from "better-scroll";

export default {
  name: "TweetDetail",
  mixins: [fromNowFilter],
  components: {
    ReplyModal,
  },
  data() {
    return {
      tweetDetail: {
        TweetAuthor: {
          avatar: "",
        },
      },
      replies: [],
      isLiked: false,
    };
  },
  mounted() {
    this.fetchTweetsDetail();
    this.movefunction(1000);
  },
  methods: {
    async fetchTweetsDetail() {
      try {
        const id = this.$route.params.id;
        const response = await tweetsAPI.getTweetDetail({ id });
        this.tweetDetail = response.data;
        // 反轉排序
        this.replies = response.data.Replies.reverse();
      } catch (error) {
        console.log(error);
      }
    },
    afterReplyTweet() {
      this.fetchTweetsDetail();
    },
    async likeTweet(id) {
      console.log(id);
      try {
        const { data } = await tweetsAPI.likeTweets(id);

        if (data.status === "error") {
          throw new Error(data.message);
        }

        Toast.fire({
          icon: "success",
          title: data.message,
        });

        await this.fetchTweetsDetail();
      } catch (error) {
        Toast.fire({
          icon: "warning",
          title: error.message,
        });
      }
    },
    async unlikeTweet(id) {
      console.log(id);
      try {
        const { data } = await tweetsAPI.unLikeTweets(id);

        if (data.status === "error") {
          throw new Error(data.message);
        }

        Toast.fire({
          icon: "success",
          title: data.message,
        });

        await this.fetchTweetsDetail();
      } catch (error) {
        Toast.fire({
          icon: "warning",
          title: error.message,
        });
      }
    },
    movefunction(s) {
      return new Promise(function (resolve) {
        setTimeout(() => {
          resolve(
            new BetterScroll(".contents_scroll", {
              mouseWheel: true, //開啟滑鼠滾動
              disableMouse: false, //關閉滑鼠拖動
              disableTouch: false, //關閉手指觸摸
              scrollX: true, //X軸滾動開啟
              click: true,
            })
          );
        }, s);
      });
    },
  },
};
